import axios from 'axios';
import API_BASE_URL from './api';

const API = `${API_BASE_URL}/api`;
const authHeaders = (token) => (token ? { Authorization: `Bearer ${token}` } : {});

export const adminListMedia = async ({ media_type, q, status, limit = 50, offset = 0 }, token) => {
  const params = {};
  if (media_type) params.media_type = media_type;
  if (q) params.q = q;
  if (status) params.status = status;
  params.limit = limit;
  params.offset = offset;
  const res = await axios.get(`${API}/media/items/admin`, { params, withCredentials: true, headers: authHeaders(token) });
  return res.data;
};

export const createMedia = async (payload, token) => {
  const res = await axios.post(`${API}/media/items`, payload, { withCredentials: true, headers: authHeaders(token) });
  return res.data;
};

export const updateMedia = async (id, payload, token) => {
  const res = await axios.put(`${API}/media/items/${id}`, payload, { withCredentials: true, headers: authHeaders(token) });
  return res.data;
};

export const deleteMedia = async (id, token) => {
  const res = await axios.delete(`${API}/media/items/${id}`, { withCredentials: true, headers: authHeaders(token) });
  return res.data;
};

export const uploadMediaFile = async (file, token) => {
  const form = new FormData();
  form.append('file', file);
  const res = await axios.post(`${API}/media/upload`, form, { withCredentials: true, headers: { ...authHeaders(token), 'Content-Type': 'multipart/form-data' } });
  return res.data; // {url}
};

// Upload de plusieurs fichiers en une seule requête. Retourne {uploaded:[{url,original_name}], errors:[]}
export const uploadMediaFiles = async (files, token) => {
  const form = new FormData();
  Array.from(files).forEach((f) => form.append('files', f));
  const res = await axios.post(`${API}/media/upload-multiple`, form, { withCredentials: true, headers: { ...authHeaders(token), 'Content-Type': 'multipart/form-data' } });
  return res.data;
};